import { terms } from '../../language/terms';

/**
 * How a stored audit category reads, in the Category filter and in each row's badge alike, so
 * ticking a category lists rows that carry the same word (#398 C17b review 2 N1). A category that
 * names a domain concept reads as its term: Domain is terms.userGroupDomain, Group is the company
 * (terms.loginGroup, #398 C16d), User and Site their own terms. Role and Assignment are security
 * mechanics with no term, and read as stored.
 */
const AUDIT_CATEGORY_TERMS: Readonly<Record<string, string>> = {
  domain: terms.userGroupDomain.value,
  group: terms.loginGroup.value,
  user: terms.loginUser.value,
  site: terms.loginSite.value,
};

export function auditCategoryLabel(category: string): string {
  return AUDIT_CATEGORY_TERMS[category.trim().toLowerCase()] ?? category;
}
